import React from "react";

const Terms_Conditions = () => {
    return (
        <div className="container py-5">
            <div className="card shadow-lg border-0 rounded-4">
                <div className="card-body p-4 p-md-5">
                    {/* Header */}
                    <div className="border-bottom border-danger border-2 pb-4 mb-4">
                        <h1 className="display-5 fw-bold text-dark">
                            CERA <span className="text-danger">STAR MASON</span>
                        </h1>
                        <h2 className="h4 fw-semibold text-secondary mt-1">
                            LOYALTY PROGRAM
                        </h2>
                        <div className="d-flex flex-wrap gap-4 mt-2 text-muted small">
                            <span>
                                <strong>Effective Date:</strong> June 2026
                            </span>
                            <span>
                                <strong>Application:</strong> CERA StarMason
                            </span>
                            <span>
                                <strong>Website:</strong>{" "}
                                <a
                                    href="https://cerastarmason.com"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-danger text-decoration-none"
                                >
                                    cerastarmason.com
                                </a>
                            </span>
                            <span>
                                <strong>Issued By:</strong> CERA Sanitaryware Limited
                            </span>
                        </div>
                    </div>

                    {/* A. GENERAL TERMS */}
                    <Section title="A. GENERAL TERMS">
                        <li>
                            The CERA Star Mason Loyalty Program ("Program") is a voluntary
                            promotional and loyalty initiative of CERA Sanitaryware Limited
                            ("CERA") for eligible masons in India.
                        </li>
                        <li>
                            By registering, accessing, or participating in the Program, the
                            participant agrees to be bound by these Terms &amp; Conditions.
                        </li>
                        <li>
                            Participation in the Program is entirely voluntary and does not
                            create any legal entitlement, contractual right, employment
                            relationship, agency relationship, partnership, franchise, or
                            joint venture between the participant and CERA.
                        </li>
                        <li>
                            CERA reserves the right to modify, suspend, discontinue, withdraw,
                            or terminate the Program, wholly or partially, at any time without
                            prior notice.
                        </li>
                        <li>
                            CERA reserves the right to suspend account access, Star accrual,
                            redemption, and participation during investigation of suspected
                            fraud or misuse.
                        </li>
                        <li>
                            The decision of CERA on all matters relating to the Program shall
                            be final and binding.
                        </li>
                        <li>
                            CERA shall not be responsible for payout failures arising from
                            incorrect UPI IDs, incorrect bank account details, frozen
                            accounts, account restrictions, or participant errors.
                        </li>
                    </Section>

                    {/* B. ELIGIBILITY */}
                    <Section title="B. ELIGIBILITY">
                        <li>
                            Only practicing masons residing in India and aged 18 years or
                            above are eligible.
                        </li>
                        <li>
                            Registration is subject to validation and approval by the CERA
                            Sales Team.
                        </li>
                        <li>
                            The participant must possess a valid Aadhaar Card, PAN Card, and
                            KYC documents.
                        </li>
                        <li>
                            Employees, officers, agents, distributors, program administrators,
                            technology partners, contractors, and their immediate family
                            members are not eligible unless specifically approved by CERA.
                        </li>
                        <li>
                            A participant may register in only one CERA loyalty program.
                            Simultaneous participation in CERA Superstar, CERA Star Mason, and
                            CERA Star Plumber is prohibited.
                        </li>
                    </Section>

                    {/* C. REGISTRATION */}
                    <Section title="C. REGISTRATION">
                        <li>
                            Registration shall be completed only through the CERA Star Mason
                            Mobile Application available on the Google Play Store.
                        </li>
                        <li>
                            Registration requires submission of accurate and complete
                            personal, Aadhaar, PAN, KYC, and banking details.
                        </li>
                        <li>Only one mobile number may be registered per participant.</li>
                        <li>
                            If a registration request is rejected, re-registration using the
                            same mobile number shall not be permitted unless approved by CERA.
                        </li>
                        <li>
                            CERA reserves the right to seek additional documents or
                            information for verification.
                        </li>
                    </Section>

                    {/* D. APPROVAL WORKFLOW */}
                    <Section title="D. APPROVAL WORKFLOW">
                        <li>
                            Registration and participation shall be subject to:
                            <ul className="mt-2 ms-4">
                                <li>Registration Approval</li>
                                <li>Image Verification by the Sales Team</li>
                                <li>KYC Approval</li>
                            </ul>
                        </li>
                        <li>
                            CERA may reject any application at any stage if information is
                            found inaccurate, incomplete, false, misleading, or fraudulent.
                        </li>
                    </Section>

                    {/* E. EARNING OF STARS */}
                    <Section title="E. EARNING OF STARS">
                        <li>
                            Stars may be earned only through successful scanning of valid QR
                            Codes available on eligible CERA products.
                        </li>
                        <li>
                            Only products purchased from Authorized Dealers and Retailers of
                            CERA shall qualify under the Program.
                        </li>
                        <li>
                            No Stars shall be awarded for duplicate scans, manipulated scans,
                            fraudulent scans, damaged QR codes, invalid QR codes, or
                            suspicious transactions.
                        </li>
                        <li>
                            All Stars shall be awarded based on the reward matrix prescribed
                            by CERA from time to time.
                        </li>
                        <li>
                            One (1) Star shall be equivalent to INR 1 unless otherwise revised
                            by CERA.
                        </li>
                        <li>
                            Stars are non-transferable and cannot be exchanged, assigned,
                            gifted, or sold.
                        </li>
                        <li>
                            Stars do not constitute cash, salary, commission, compensation,
                            legal dues, or vested rights.
                        </li>
                    </Section>

                    {/* F. REDEMPTION */}
                    <Section title="F. REDEMPTION">
                        <li>
                            Stars may be redeemed through:
                            <ul className="mt-2 ms-4">
                                <li>UPI Transfer</li>
                                <li>Bank Transfer</li>
                                <li>Paytm Wallet (where applicable)</li>
                                <li>E-Vouchers</li>
                                <li>Gift Vouchers</li>
                                <li>Merchandise</li>
                                <li>Physical Products available in the Reward Catalogue</li>
                            </ul>
                        </li>
                        <li>
                            Redemption shall be allowed only if:
                            <ul className="mt-2 ms-4">
                                <li>Minimum 500 Stars are available.</li>
                                <li>Image Verification is completed.</li>
                                <li>KYC is approved.</li>
                                <li>Bank details are verified.</li>
                            </ul>
                        </li>
                        <li>
                            Redemption requests once processed cannot be cancelled or
                            reversed.
                        </li>
                        <li>
                            Reward availability shall be subject to stock availability and
                            operational feasibility.
                        </li>
                        <li>
                            CERA shall not be responsible for quality, warranty,
                            merchantability, after-sales service, replacement, installation,
                            or performance of third-party rewards.
                        </li>
                    </Section>

                    {/* G. PAN, AADHAAR & TAX COMPLIANCE */}
                    <Section title="G. PAN, AADHAAR &amp; TAX COMPLIANCE">
                        <li>
                            Participants expressly consent to providing Aadhaar, PAN, bank
                            account details, and KYC information.
                        </li>
                        <li>
                            Such information may be used for:
                            <ul className="mt-2 ms-4">
                                <li>Identity Verification</li>
                                <li>KYC Compliance</li>
                                <li>Reward Processing</li>
                                <li>TDS Deduction</li>
                                <li>Income Tax Reporting</li>
                                <li>Audit Requirements</li>
                                <li>Fraud Prevention</li>
                                <li>Statutory Compliance</li>
                            </ul>
                        </li>
                        <li>
                            Wherever applicable under law, TDS may be deducted prior to
                            reward disbursement.
                        </li>
                    </Section>

                    {/* H. COMMUNICATION CONSENT */}
                    <Section title="H. COMMUNICATION CONSENT">
                        <li>
                            Participants consent to receive communications through:
                            <ul className="mt-2 ms-4">
                                <li>Phone Calls</li>
                                <li>SMS</li>
                                <li>WhatsApp</li>
                                <li>Emails</li>
                                <li>Mobile App Notifications</li>
                            </ul>
                        </li>
                        <li>
                            Communications may include OTPs, verification requests, point
                            credits, redemption confirmations, program updates, surveys,
                            support communications, promotional offers, and marketing
                            campaigns.
                        </li>
                    </Section>

                    {/* I. DATA PRIVACY & DPDP ACT 2023 */}
                    <Section title="I. DATA PRIVACY &amp; DPDP ACT 2023">
                        <li>
                            CERA acts as the Data Fiduciary under the Digital Personal Data
                            Protection Act, 2023.
                        </li>
                        <li>
                            By registering, participants provide free, informed, specific,
                            unconditional, and unambiguous consent for collection, storage,
                            processing, verification, and sharing of personal data.
                        </li>
                        <li>
                            Personal data collected may include:
                            <ul className="mt-2 ms-4">
                                <li>Name</li>
                                <li>Mobile Number</li>
                                <li>Address</li>
                                <li>Aadhaar Details</li>
                                <li>PAN Details</li>
                                <li>Bank Account Details</li>
                                <li>UPI ID</li>
                                <li>KYC Documents</li>
                                <li>Photographs</li>
                                <li>QR Scan Records</li>
                                <li>Device Information</li>
                                <li>Transaction History</li>
                            </ul>
                        </li>
                        <li>
                            Personal data may be processed for program administration, loyalty
                            management, reward processing, tax compliance, fraud prevention,
                            analytics, and regulatory obligations.
                        </li>
                        <li>
                            Participants shall have rights under the DPDP Act including
                            access, correction, erasure, grievance redressal, nomination, and
                            consent withdrawal.
                        </li>
                        <li>
                            Withdrawal of consent may result in suspension or termination of
                            participation.
                        </li>
                        <li>
                            The Privacy Notice governing collection, processing, storage,
                            sharing, retention, and usage of personal data shall be made
                            available through the Program website, mobile application, or
                            other official communication channels.
                        </li>
                        <li>
                            Participants may withdraw consent through the mobile application,
                            website, customer support channel, Grievance Officer, or such
                            other mechanism as may be prescribed by CERA. Withdrawal of
                            consent may impact participation in the Program.
                        </li>
                        <li>
                            Personal data shall be retained only for the period necessary for
                            Program administration, legal compliance, audit requirements, tax
                            obligations, dispute resolution, and regulatory requirements. Upon
                            expiry of such period, personal data shall be deleted or
                            anonymized in accordance with applicable law.
                        </li>
                        <li>
                            Participants may contact the designated Grievance Officer for
                            privacy-related concerns, correction requests, consent withdrawal
                            requests, and grievance redressal.
                        </li>
                    </Section>

                    {/* J. FRAUD, MISUSE & NEGATIVE BALANCE */}
                    <Section title="J. FRAUD, MISUSE &amp; NEGATIVE BALANCE">
                        <li>
                            Any fraudulent activity, duplicate account creation, fake
                            registrations, QR manipulation, or submission of false documents
                            shall result in suspension, cancellation, forfeiture of Stars, and
                            legal action.
                        </li>
                        <li>
                            If Stars are mistakenly credited due to technical errors,
                            duplicate transactions, operational discrepancies, or system
                            issues, CERA reserves the right to reverse such Stars.
                        </li>
                        <li>Such reversals may result in a negative Star balance.</li>
                        <li>
                            Future Stars earned may be adjusted against the negative balance
                            until recovery is completed.
                        </li>
                        <li>
                            Participants having a negative balance shall not be permitted to
                            redeem Stars until the account is regularized.
                        </li>
                    </Section>

                    {/* K. TAMIL NADU COMPLIANCE */}
                    <Section title="K. TAMIL NADU COMPLIANCE">
                        <li>
                            Any reward, incentive, or benefit that may fall within the ambit
                            of The Lotteries (Regulation) Act, 1998 shall not be available to
                            participants located in the State of Tamil Nadu to the extent
                            prohibited under applicable law.
                        </li>
                    </Section>

                    {/* L. LIMITATION OF LIABILITY */}
                    <Section title="L. LIMITATION OF LIABILITY">
                        <li>
                            CERA shall not be liable for any direct, indirect, incidental,
                            consequential, special, or punitive damages arising from
                            participation in the Program.
                        </li>
                        <li>
                            CERA shall not be liable for technical failures, internet issues,
                            system outages, pandemics, governmental restrictions, labour
                            disruptions, natural disasters, or any force majeure event.
                        </li>
                    </Section>

                    {/* M. DISPUTE RESOLUTION & JURISDICTION */}
                    <Section title="M. DISPUTE RESOLUTION &amp; JURISDICTION">
                        <li>
                            Any dispute relating to Stars, rewards, redemptions, account
                            status, verification, or program participation shall first be
                            referred to CERA.
                        </li>
                        <li>
                            CERA may appoint an internal review committee whose decision shall
                            be final and binding.
                        </li>
                        <li>These Terms shall be governed by the laws of India.</li>
                        <li>
                            All disputes shall be subject to the exclusive jurisdiction of the
                            courts at Ahmedabad, Gujarat.
                        </li>
                        <li>
                            Any dispute relating to QR scan failure, scan rejection, duplicate
                            scan detection, or Star allocation must be reported within fifteen
                            (15) days from the date of transaction.
                        </li>
                    </Section>

                    {/* DECLARATION */}
                    <div className="mt-5 p-4 bg-light border rounded-4">
                        <h3 className="h4 fw-bold text-dark border-start border-danger border-4 ps-3 mb-3">
                            DECLARATION
                        </h3>
                        <ul className="list-unstyled">
                            <li className="mb-2">✓ I am above 18 years of age.</li>
                            <li className="mb-2">
                                ✓ I have voluntarily enrolled in the CERA Star Mason Program.
                            </li>
                            <li className="mb-2">
                                ✓ All information provided by me is true and accurate.
                            </li>
                            <li className="mb-2">
                                ✓ I consent to the collection, processing, storage, and use of
                                my personal data.
                            </li>
                            <li className="mb-2">
                                ✓ I authorize CERA to use my Aadhaar, PAN, KYC, and banking
                                information for verification, reward processing, TDS deduction,
                                audit, and statutory compliance.
                            </li>
                            <li className="mb-2">
                                ✓ I consent to receive communications through Call, SMS,
                                WhatsApp, Email, and Mobile Application notifications.
                            </li>
                        </ul>
                        <p className="mt-3 text-muted small">
                            Participants may opt out of promotional communications in
                            accordance with applicable law. Transactional communications
                            necessary for Program administration may continue irrespective of
                            communication preferences.
                        </p>
                        <p className="mt-2 fw-semibold">
                            I have read, understood, and accepted these Terms &amp;
                            Conditions.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

// Helper Component for Sections
const Section = ({ title, children }) => {
    return (
        <div className="mt-4">
            <h3 className="h4 fw-bold text-dark border-start border-danger border-4 ps-3 mb-3">
                {title}
            </h3>
            <ul className="list-unstyled ps-4">
                {React.Children.map(children, (child) => (
                    <li className="mb-2 position-relative ps-3">
                        <span className="position-absolute start-0 text-danger">•</span>
                        {child}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default Terms_Conditions;